export enum Site {
  Voghion = 'voghion',
  Desvips = 'desvips',
  Ipsvogv = 'ipsvogv',
  Maomaolike = 'maomaolike',
  Mkmklike = 'mkmklike',
  Vogvips = 'vogvips'
}

type SiteConfig = {
  mainDomain: string
  gtmId: string
  facebookPixelId: string
  needConsent: boolean
}

const sites = new Map<Site, SiteConfig>([
  [
    Site.Voghion,
    {
      mainDomain: 'voghion.com',
      gtmId: 'GTM-KTCZG4Z',
      facebookPixelId: '725148525961077',
      needConsent: true
    }
  ],
  [
    Site.Desvips,
    {
      mainDomain: 'desvips.com',
      gtmId: 'GTM-5GJHZC8K',
      facebookPixelId: '378279881747071',
      needConsent: false
    }
  ],
  [
    Site.Ipsvogv,
    {
      mainDomain: 'ipsvogv.com',
      gtmId: 'GTM-5SCS69MM',
      facebookPixelId: '352324073946749',
      needConsent: false
    }
  ],
  [
    Site.Maomaolike,
    {
      mainDomain: 'maomaolike.com',
      gtmId: 'GTM-MB526549',
      facebookPixelId: '960734765532833',
      needConsent: false
    }
  ],
  [
    Site.Mkmklike,
    {
      mainDomain: 'mkmklike.com',
      gtmId: 'GTM-52NZ6NCP',
      facebookPixelId: '933083574923905',
      needConsent: false
    }
  ],
  [
    Site.Vogvips,
    {
      mainDomain: 'vogvips.com',
      gtmId: 'GTM-W4CKFWHS',
      facebookPixelId: '429825629540193',
      needConsent: false
    }
  ]
])

/**
 * 获取当前站点
 */
export const getCurrentSite = () => {
  for (const [site, config] of sites.entries()) {
    if (location.hostname.includes(config.mainDomain)) {
      return site
    }
  }
  return Site.Voghion
}

/**
 * 获取站点配置
 * @param site
 * @returns
 */
export const getSiteConfig = (site: Site) => {
  return sites.get(site)
}

/**
 * 获取当前站点的配置
 */
export const getCurrentSiteConfig = () => {
  const site = getCurrentSite()
  return getSiteConfig(site)
}
